import styled from 'styled-components';
import { spacing, Box, palette, Group } from '@landr/maestro';

const DesktopOnlyGroup = styled(Group)`
    align-items: center;
    display: flex;
    margin-right: ${spacing('sm')};

    ${({ theme }): string => theme.breakpoint('md')`
        display: none;
    `}
`;

const MobileOnlyGroup = styled(Group)`
    align-items: center;
    display: none;

    ${({ theme }): string => theme.breakpoint('md')`
        display: flex;
    `}
`;

const Separator = styled(Box)`
    height: 48px;
    width: 1px;
    background-color: ${palette('neutral.200')};

    ${({ theme }): string => theme.breakpoint('md')`
        display: none;
    `}
`;

const CreatorHeaderWrapper = styled.div`
    position: relative;
`;

export default {
    DesktopOnlyGroup,
    MobileOnlyGroup,
    Separator,
    CreatorHeaderWrapper,
};
